import apiWrapper, { getMethod } from './helpers';

export default class FederationAdjustment extends apiWrapper('/federation_adjustments') {

  static summary = getMethod('/federation_adjustments/summary')

}
